import { System } from 'src/app/@framework/core/clms.fw.dotnet';
import * as Domain from '../Domain';
import * as Common from '../../@framework/common';
import { CLMS  } from 'src/app/@framework/core/clms.fw.common';
import { Joove } from 'src/app/@framework/core/Joove';
import * as moment from 'moment';
import { TranslateService } from '@ngx-translate/core';
import { DataListColumnInfo, DataListColumnItemType, ListDynamicColumnValue } from '@framework/components/DataList/helpers/List.helper.classes';
import { ValueFormat } from '@framework/core/clms.fw.angular';
var numeral = require('numeral');
const VerEx = require('verbal-expressions');


export class PayrollVariableInstanceDTO  {
    _originalTypeClassName = "zERP.BO.PayrollVariableInstanceDTO";
constructor(protected translateService: TranslateService = null) {
if (translateService != null) {
PayrollVariableInstanceDTO.translate = translateService;
}
this.Id = null;
this.Value = null;
this.PayrollVariableInstanceDTOKey = null;
this._key = this.PayrollVariableInstanceDTOKey = 0; 
}

static translate: TranslateService;
_key: any;
Id:any;
Value:any;
VariableDTO:any;
private _PayrollVariableInstanceDTOKey:any;
get PayrollVariableInstanceDTOKey(): any {
    return this._PayrollVariableInstanceDTOKey;
  }
set PayrollVariableInstanceDTOKey(value: any) {
    this._PayrollVariableInstanceDTOKey = value;
    this._key = value;
  }
static setVariableDTO = ($this, value) => {
var oldValue = $this.VariableDTO;
$this.VariableDTO = value;
if (value != null) {
}
}

static Assign(pvi: any): any{let pviDTO = new Domain.PayrollVariableInstanceDTO();
pviDTO.Id = pvi?.Id;
pviDTO.Value = pvi?.Value;
Domain.PayrollVariableInstanceDTO.setVariableDTO(pviDTO, Domain.PayrollVariableDTO.Assign(pvi?.Variable));
return pviDTO;
}

static IsNew($this: any): boolean {
                if ($this == null) return true;
                return $this.PayrollVariableInstanceDTOKey == null || $this.PayrollVariableInstanceDTOKey == 0;
            }


}